import showCard from "./show_card/show_card";
import materials_list from "./materials_list/materials_list";
import consumptions_history from "./consumptions_history/consumptions_history";

export default {
  show_card: showCard,
  materials_list: materials_list,
  consumptions_history: consumptions_history,
};
